export const PasswordlessLoginExperimentKey = 'KRK-637';
export const passwordlessLogin = {
    [PasswordlessLoginExperimentKey]: {
        experimentId: '5667512268881920',
        variantsIds: {
            A: '5145256660828160', // Original
            B: '5374147480518656', // Variation #1
        },
    },
};
//# sourceMappingURL=passwordlessLogin.js.map